// import { useEffect, useState } from "react";
// import { useParams, useLocation } from "react-router-dom";
// import axios from "axios";
// import "../styles/Invoice.css";
// import logo from "../assets/medicare_logo.png";
// import html2pdf from "html2pdf.js";
// import { useNavigate } from "react-router-dom";

// export default function Pharmacyinvoice() {
//   const { patientId, serial_no } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate("");
//   const { selectedMedicines, totaldrugfee } = location.state || {
//     selectedMedicines: [],
//     totaldrugfee: 0,
//   };
//   const [patients, setPatients] = useState(null);
//   const [invoicedetails, setInvoicedetails] = useState(null);
//   const [treatmentamount, setTreatmentamount] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [discountType, setDiscountType] = useState("percentage"); // Default to percentage

//   const printInvoice = () => {
//     window.print();
//   };

//   useEffect(() => {
//     const fetchPatientDetails = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
//         );
//         setPatients(response.data);
//       } catch (error) {
//         console.error("Error fetching patients:", error);
//       }
//     };

//     const fetchRecords = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
//         );
//         setInvoicedetails(response.data);
//         setTreatmentamount(response.data.MTD_AMOUNT || 0);
//       } catch (error) {
//         console.error("Error fetching records:", error);
//       }
//     };

//     fetchRecords();
//     fetchPatientDetails();
//   }, [patientId]);

//   console.log(selectedMedicines);

//   const totalAmount = treatmentamount + totaldrugfee;

//   // Discount calculation based on the selected discount type (number or percentage)
//   const calculateFinalAmount = () => {
//     let discountAmount = 0;

//     if (discountType === "percentage") {
//       discountAmount = totalAmount * (discount / 100);
//     } else if (discountType === "fixed") {
//       discountAmount = discount;
//     }

//     return totalAmount - discountAmount;
//   };

//   const generatePDF = () => {
//     const element = document.getElementById("invoice-content");
//     const opt = {
//       margin: 1,
//       filename: `invoice_${patientId}.pdf`,
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
//     };

//     html2pdf().from(element).set(opt).save();
//   };

//   return (
//     <div className="invoice-container" id="invoice-content">
//       <button className="back-button" onClick={() => navigate(-1)}>
//         Back
//       </button>
//       <header className="header2">
//         <div className="logo-container">
//           <img src={logo} alt="Medilink Logo" className="logo" />
//         </div>
//         <p>
//           85/1, Horana Road, Bandaragama.
//           <br />
//           Tel: 0771068887
//           <br />
//           Email: Medilink@gmail.com
//           <br />
//           Web: www.medilink.lk
//         </p>
//       </header>

//       <h1>Payment Receipt</h1>
//       <h3>Medilink Hospitals - Bandaragama</h3>

//       <div className="client-info">
//         <p>
//           <strong>Patient Name:</strong>{" "}
//           {patients ? patients.MPD_PATIENT_NAME : "N/A"}
//         </p>
//         <p>
//           <strong>Invoice Number:</strong>{" "}
//           {invoicedetails ? invoicedetails.MTD_SERIAL_NO : "N/A"}
//         </p>
//         <p>
//           <strong>Date:</strong> {new Date().toLocaleDateString()}
//         </p>
//       </div>

//       <div className="payment-info">
//         {selectedMedicines.length > 0 ? (
//           <div>
//             <table className="medicine-invoice-table">
//               <thead>
//                 <tr>
//                   <th>Drug Description</th>
//                   <th>Rate (Rs)</th>
//                   <th>Quantity</th>
//                   <th>Amount (Rs) </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {selectedMedicines.map((medicinedetail, index) => (
//                   <tr key={index}>
//                     <td>{medicinedetail.DrugName}</td>
//                     <td>{parseFloat(medicinedetail.MDD_RATE).toFixed(2)}</td>
//                     <td>{medicinedetail.MDD_GIVEN_QUANTITY}</td>
//                     <td>{(medicinedetail.MDD_GIVEN_QUANTITY * medicinedetail.MDD_RATE).toFixed(2)}</td>
//                   </tr>
//                 ))}
//               </tbody>

//               <tr className="total-separator">
//                 <td colSpan="2"></td>
//                 <td>Total drug Fee:</td>
//                 <td> Rs. {totaldrugfee.toFixed(2)}</td>
//               </tr>
//               <tr>
//                 <td colSpan="2"></td>
//                 <td>
//                   <strong>Treatment fee</strong>
//                 </td>
//                 <td>
//                   <strong>Rs. {treatmentamount.toFixed(2)}</strong>
//                 </td>
//               </tr>

//               <tr>
//                 <td colSpan="2"></td>

//                 <td>Total amount</td>

//                 <td>Rs. {totalAmount.toFixed(2)}</td>
//               </tr>

//               <tr className="discount-row">
//                 <td colSpan={1}></td>
//                 <td>
//                   <strong>Discount</strong>
//                 </td>
//                 <td
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "8px",
//                   }}
//                 >
//                   <label
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                     }}
//                   >
//                     <input
//                       type="radio"
//                       value="percentage"
//                       checked={discountType === "percentage"}
//                       onChange={() => setDiscountType("percentage")}
//                     />
//                     Percentage
//                   </label>

//                   <label
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                     }}
//                   >
//                     <input
//                       type="radio"
//                       value="fixed"
//                       checked={discountType === "fixed"}
//                       onChange={() => setDiscountType("fixed")}
//                     />
//                     Fixed Amount
//                   </label>
//                 </td>

//                 <td>
//                   <input
//                     type="number"
//                     value={discount}
//                     onChange={(e) => setDiscount(e.target.value)}
//                     min="0"
//                     max={discountType === "percentage" ? "100" : totalAmount}
//                   />
//                 </td>
//               </tr>

//               <tr>
//                 <td colSpan="2"></td>
//                 <td>
//                   <strong>Final amount</strong>
//                 </td>
//                 <td> Rs. {calculateFinalAmount().toFixed(2)}</td>
//               </tr>
//             </table>
//           </div>
//         ) : (
//           <p>No medicines</p>
//         )}

//         {/* <p><strong>Total Drug Fee:</strong> Rs. {totaldrugfee.toFixed(2)}</p>
//         <p><strong>Treatment Fee:</strong> Rs. {treatmentamount.toFixed(2)}</p>
//         <p><strong>Total Amount:</strong> Rs. {totalAmount.toFixed(2)}</p>

//         <p>
//           <strong>Discount:</strong>
          
          
//           <label>
//             <input 
//               type="radio" 
//               value="percentage" 
//               checked={discountType === 'percentage'} 
//               onChange={() => setDiscountType('percentage')} 
//             /> Percentage
//           </label>
//           <label>
//             <input 
//               type="radio" 
//               value="fixed" 
//               checked={discountType === 'fixed'} 
//               onChange={() => setDiscountType('fixed')} 
//             /> Number (Fixed Amount)
//           </label>

//           <input 
//             type="number" 
//             value={discount} 
//             onChange={(e) => setDiscount(e.target.value)} 
//             min="0" 
//             max={discountType === 'percentage' ? "100" : totalAmount} 
//           />
//         </p>
        


//         <p><strong>Final Amount:</strong> Rs. {calculateFinalAmount().toFixed(2)}</p> */}
//       </div>

//       <div className="btn-container1">
//         <button className="btn print" onClick={printInvoice}>
//           Print
//         </button>
//         <button className="btn download" onClick={generatePDF}>
//           Download
//         </button>
//         {/* <button className="btn send">Send</button> */}
//       </div>
//     </div>
//   );
// }

// import { useEffect, useState } from "react";
// import { useParams, useLocation } from "react-router-dom";
// import axios from "axios";
// import "../styles/Invoice.css";
// import logo from "../assets/medicare_logo.png";
// import html2pdf from "html2pdf.js";
// import { useNavigate } from "react-router-dom";

// export default function Invoice() {
//   const { patientId, serial_no } = useParams();
//   const [patients, setPatients] = useState(null);
//   const [invoicedetails, setInvoicedetails] = useState(null);
//   const [treatmentamount, setTreatmentamount] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const location = useLocation();
//   const [discountType, setDiscountType] = useState("percentage");
//   const navigate = useNavigate("");
//   const [medicinedetails, setMedicinedetails] = useState();

//   useEffect(() => {
//     const fetchRecords = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
//         );
//         setInvoicedetails(response.data);
//         setTreatmentamount(response.data.MTD_AMOUNT || 0);
//       } catch (error) {
//         console.error("Error fetching records:", error);
//       }
//     };

//     const fetchPatientDetails = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
//         );
//         setPatients(response.data);
//       } catch (error) {
//         console.error("Error fetching patients:", error);
//       }
//     };

//     fetchRecords();
//     fetchPatientDetails();
//   }, [patientId, serial_no]);

//   const calculateSubtotal = () => {
//     if (invoicedetails && invoicedetails.Drugs) {
//       const total = invoicedetails.Drugs.reduce(
//         (total, drug) => total + drug.MDD_AMOUNT,
//         0
//       );
//       return total.toFixed(2);
//     }
//     return 0;
//   };

//   const calculateTotalAmount = () => {
//     const subtotal =
//       parseFloat(calculateSubtotal()) + parseFloat(treatmentamount);
//     let totalAmount = subtotal;

//     if (discountType === "percentage") {
//       totalAmount -= (subtotal * discount) / 100;
//     } else {
//       totalAmount -= discount;
//     }

//     return totalAmount.toFixed(2);
//   };

//   const printInvoice = () => {
//     window.print();
//   };

//   const downloadInvoice = () => {
//     const invoiceElement = document.querySelector(".invoice-container");
//     invoiceElement.classList.add("hide-elements");

//     const opt = {
//       margin: 1,
//       filename: `invoice_${patientId}.pdf`,
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
//     };

//     html2pdf()
//       .from(invoiceElement)
//       .set(opt)
//       .save()
//       .then(() => {
//         invoiceElement.classList.remove("hide-elements");
//       });
//   };

//   return (
//     <div>
//       <div className="invoice-container">
//         <button className="back-button" onClick={() => navigate(-1)}>
//           Back
//         </button>

//         <header className="header2">
//           <div className="logo-container">
//             <img src={logo} alt="Medilink Logo" className="logo" />
//           </div>
//           <p>
//             85/1, Horana Road, Bandaragama.
//             <br />
//             Tel: 0771068887
//             <br />
//             Email: Medilink@gmail.com
//             <br />
//             Web: www.medilink.lk
//           </p>
//         </header>

//         <h1>Payment Receipt</h1>
//         <h3>Medicare hospitals </h3>

//         <div className="client-info">
//           <p>
//             <strong>Patient Name:</strong>{" "}
//             {patients ? patients.MPD_PATIENT_NAME : "N/A"}
//           </p>
//           <p>
//             <strong>Invoice Number:</strong>{" "}
//             {invoicedetails ? invoicedetails.MTD_SERIAL_NO : "N/A"}
//           </p>
//           <p>
//             <strong>Date:</strong> {new Date().toISOString().split("T")[0]}
//           </p>
//         </div>

//         <div className="payment-info">
//           {invoicedetails &&
//           invoicedetails.Drugs &&
//           invoicedetails.Drugs.length > 0 ? (
//             <div>
//               {/* <h3>Medicine Details</h3> */}
//               <table className="medicine-invoice-table">
//                 <thead>
//                   <tr>
//                     <th>Drug Description</th>
//                     <th>Rate (Rs)</th>
//                     <th>Quantity</th>
//                     <th>Amount (Rs) </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {invoicedetails.Drugs.map((medicinedetail, index) => (
//                     <tr key={index}>
//                       <td>{medicinedetail.DrugName}</td>
//                       <td> {parseFloat(medicinedetail.MDD_RATE).toFixed(2)}</td>
//                       <td>{medicinedetail.MDD_QUANTITY}</td>
//                       <td>
//                         {parseFloat(medicinedetail.MDD_AMOUNT).toFixed(2)}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>

//                 {/* Extra rows for totals */}
//                 <tr className="total-separator">
//                   <td colSpan="2"></td> {/* Empty columns */}
//                   <td>
//                     <strong>Total Drug Fee:</strong>
//                   </td>
//                   <td>
//                     <strong>Rs: {calculateSubtotal()}</strong>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan="2"></td> {/* Empty columns */}
//                   <td>
//                     <strong>Treatment Fee:</strong>
//                   </td>
//                   <td>
//                     <strong>Rs: {treatmentamount.toFixed(2)}</strong>
//                   </td>
//                 </tr>

//                 <tr>
//                   <td colSpan="2"></td> {/* Empty columns */}
//                   <td>
//                     <strong>Total amout:</strong>
//                   </td>
//                   <td>
//                     <strong>
//                       Rs:{" "}
//                       {(
//                         parseFloat(calculateSubtotal()) +
//                         parseFloat(treatmentamount)
//                       ).toFixed(2)}
//                     </strong>
//                   </td>
//                 </tr>

//                 <tr className="discount-row">
//                   <td colSpan={1}></td>
//                   <td>
//                     <strong>Discount</strong>
//                   </td>
//                   <td
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "8px",
//                     }}
//                   >
//                     <label
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "5px",
//                       }}
//                     >
//                       <input
//                         type="radio"
//                         value="percentage"
//                         checked={discountType === "percentage"}
//                         onChange={() => setDiscountType("percentage")}
//                       />
//                       Percentage
//                     </label>
//                     <label
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "5px",
//                       }}
//                     >
//                       <input
//                         type="radio"
//                         value="fixed"
//                         checked={discountType === "fixed"}
//                         onChange={() => setDiscountType("fixed")}
//                       />
//                       Fixed Amount
//                     </label>
//                   </td>
//                   <td>
//                     <input
//                       type="number"
//                       value={discount}
//                       onChange={(e) => setDiscount(e.target.value)}
//                       min="0"
//                       max={
//                         discountType === "percentage"
//                           ? "100"
//                           : parseFloat(calculateSubtotal()) +
//                             parseFloat(treatmentamount)
//                       }
//                     />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td colSpan="2"></td>

//                   <td>
//                     <strong>Final amout:</strong>
//                   </td>
//                   <td>
//                     <strong> Rs: {calculateTotalAmount()}</strong>
//                   </td>
//                 </tr>
//               </table>
//             </div>
//           ) : (
//             <p>No medicines found</p>
//           )}

//           <div className="">
//             {/* <p><strong>Total Drug Fee:</strong> Rs: {calculateSubtotal()}</p>
//                         <p><strong>Treatment Fee:</strong> Rs: {treatmentamount.toFixed(2)}</p> */}
//             {/* <p><strong>Total Amount:</strong> Rs: {parseFloat(calculateSubtotal()) + parseFloat(treatmentamount)}</p> */}

//             {/* <p><strong>Discount:</strong> */}
//             {/* <label>
//                                 <input
//                                     type="radio"
//                                     value="percentage"
//                                     checked={discountType === 'percentage'}
//                                     onChange={() => setDiscountType('percentage')}
//                                 /> Percentage
//                             </label>
//                             <label>
//                                 <input
//                                     type="radio"
//                                     value="fixed"
//                                     checked={discountType === 'fixed'}
//                                     onChange={() => setDiscountType('fixed')}
//                                 /> Fixed Amount
//                             </label>
//                             <input
//                                 type="number"
//                                 value={discount}
//                                 onChange={(e) => setDiscount(e.target.value)}
//                                 min="0"
//                                 max={discountType === 'percentage' ? "100" : parseFloat(calculateSubtotal()) + parseFloat(treatmentamount)}
//                             />
//                         </p> */}
//           </div>
//         </div>

//         <div className="btn-container1">
//           <button className="btn print" onClick={printInvoice}>
//             Print
//           </button>
//           <button className="btn download" onClick={downloadInvoice}>
//             Download
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }




import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Grid,
  Tooltip,
  CircularProgress,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Alert,
  Snackbar,
} from "@mui/material";
import {
  ArrowBack,
  Print,
  Download,
  LocalHospital,
  Person,
  Receipt,
  Phone,
  Email,
  Language,
  Home,
  CalendarToday,
  Male,
  Female,
  ReceiptLong,
  ContentCopy,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import logo from "../assets/AuraLogo.png";
import html2pdf from "html2pdf.js";
import { NumericFormat } from 'react-number-format';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
  maxWidth: 1500,
  margin: "0 auto",
  "@media print": {
    boxShadow: "none",
    padding: theme.spacing(3),
    border: "1px solid #ddd",
  },
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(4),
  "@media (max-width: 600px)": {
    flexDirection: "column",
    gap: theme.spacing(2),
    alignItems: "flex-start",
  },
  "@media print": {
    flexDirection: "row",
    alignItems: "center",
  },
}));

const TotalRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  "& td": {
    fontWeight: "bold",
    fontSize: "1.1rem",
  },
}));

const DiscountRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  "& td": {
    padding: theme.spacing(2),
  },
}));

const InvoiceNumberBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: 'white',
  padding: '6px 12px',
  borderRadius: '16px',
  display: 'inline-block',
  marginTop: theme.spacing(1),
  fontSize: '0.875rem',
  fontWeight: 500,
  '-webkit-print-color-adjust': 'exact',
  'color-adjust': 'exact',
  'print-color-adjust': 'exact',
}));

// Thermal Receipt Component
const ThermalReceipt = ({ 
  open, 
  onClose, 
  patients, 
  invoicedetails, 
  treatmentamount, 
  discount, 
  discountType, 
  calculateSubtotal, 
  calculateTotalAmount 
}) => {
  const [printStatus, setPrintStatus] = useState({ open: false, message: '', severity: 'info' });

  const showMessage = (message, severity = 'info') => {
    setPrintStatus({ open: true, message, severity });
  };

  // Generate thermal receipt text for 80mm printer
  const generateThermalReceipt = () => {
    const LINE_WIDTH = 48; // 80mm thermal printer width
    const subtotal = Number(calculateSubtotal()) + Number(treatmentamount);
    const totalAmount = Number(calculateTotalAmount());
    
    const centerText = (text, width = LINE_WIDTH) => {
      const padding = Math.max(0, Math.floor((width - text.length) / 2));
      return ' '.repeat(padding) + text;
    };

    const formatAmount = (amount) => {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(amount));
    };

    const formatLine = (left, right, width = LINE_WIDTH) => {
      const space = width - (left.length + right.length);
      return left + ' '.repeat(Math.max(1, space)) + right;
    };

    const divider = (char = '-') => char.repeat(LINE_WIDTH);

    const receiptLines = [
      centerText('AURA HEALTHCARE'),
      centerText('No:128/1,Pahala karagahamuna,Kadawatha.'),
      centerText('Tel: 0114532108 | 0117905805'),
      centerText('Email: akdldhshana@gmail.com'),
      '',
      divider('='),
      centerText('PAYMENT RECEIPT'),
      divider('='),
      '',
      formatLine('Invoice:', invoicedetails?.MTD_SERIAL_NO || 'N/A'),
      formatLine('Date:', new Date().toLocaleDateString('en-GB')),
      formatLine('Time:', new Date().toLocaleTimeString('en-GB', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: false 
      })),
      '',
      divider('-'),
      centerText('PATIENT DETAILS'),
      divider('-'),
      `Name: ${patients?.MPD_PATIENT_NAME || 'N/A'}`,
      `Addr: ${(patients?.MPD_ADDRESS || 'Not specified').substring(0, 30)}`,
      `Gender/Age: ${patients?.MPD_GENDER || 'N/A'}/${
        patients?.MPD_BIRTHDAY ? 
        new Date().getFullYear() - new Date(patients.MPD_BIRTHDAY).getFullYear() : 'N/A'
      }`,
      '',
      divider('-'),
      centerText('BILLING DETAILS'),
      divider('-'),
      'Item                Qty  Price    Amount',
      divider('-'),
    ];

    // Add medicine items
    if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
      invoicedetails.Drugs.forEach(medicinedetail => {
        const name = medicinedetail.DrugName.length > 20 ? 
          medicinedetail.DrugName.substring(0, 20) : medicinedetail.DrugName;
        const qty = medicinedetail.MDD_QUANTITY.toString().padStart(3);
        const rate = formatAmount(medicinedetail.MDD_RATE).padStart(6);
        const amount = formatAmount(medicinedetail.MDD_AMOUNT).padStart(8);
        
        receiptLines.push(`${name.padEnd(20)} ${qty} ${rate} ${amount}`);
      });
    } else {
      receiptLines.push('No medications'.padEnd(LINE_WIDTH));
    }

    // Add totals
    receiptLines.push(
      '',
      divider('-'),
      ...(invoicedetails?.Drugs?.length > 0 ? [
        formatLine('Drug Subtotal:', `Rs. ${formatAmount(calculateSubtotal())}`)
      ] : []),
      formatLine('Treatment Fee:', `Rs. ${formatAmount(treatmentamount)}`),
      formatLine('Subtotal:', `Rs. ${formatAmount(subtotal)}`),
      ...(discount > 0 ? [
        formatLine(
          'Discount:', 
          discountType === 'percentage' ? 
          `-${discount}%` : 
          `-Rs. ${formatAmount(discount)}`
        )
      ] : []),
      divider('='),
      formatLine('TOTAL:', `Rs. ${formatAmount(totalAmount)}`),
      divider('='),
      '',
      centerText('THANK YOU!'),
      centerText('AURA MEDITATION'),
      '',
      centerText('Authorized Signature'),
      '',
      divider('*'),
      centerText(new Date().toLocaleString('en-GB')),
      '', '', '', '', '' // Extra lines for paper cut
    );

    return receiptLines.join('\n');
  };

  const printThermalReceipt = () => {
    const receiptText = generateThermalReceipt();
    
    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      showMessage('Please allow popups to print receipt', 'warning');
      return;
    }

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Thermal Receipt - ${invoicedetails?.MTD_SERIAL_NO || 'Invoice'}</title>
          <style>
            @media print {
              @page {
                margin: 0;
                size: 80mm auto;
              }
              body {
                margin: 0;
                padding: 5mm;
                font-family: 'Courier New', monospace;
                font-size: 12px;
                line-height: 1.2;
                width: 80mm;
                background: white;
                color: black;
              }
            }
            body {
              font-family: 'Courier New', monospace;
              font-size: 12px;
              line-height: 1.2;
              margin: 0;
              padding: 10px;
              white-space: pre;
              background: white;
              color: black;
              width: 80mm;
            }
            .no-print {
              display: none;
            }
            .print-button {
              position: fixed;
              top: 10px;
              right: 10px;
              background: #1976d2;
              color: white;
              border: none;
              padding: 10px 15px;
              border-radius: 5px;
              cursor: pointer;
              z-index: 1000;
            }
          </style>
        </head>
        <body>
          <pre>${receiptText}</pre>
          <div class="no-print">
            <br>
            <button class="print-button" onclick="window.print()">Print Thermal Receipt</button>
            <button onclick="window.close()">Close</button>
          </div>
          <script>
            window.onload = function() {
              // Auto-print after a short delay
              setTimeout(() => {
                window.print();
                // Auto-close after printing (optional)
                setTimeout(() => {
                  if (confirm('Close this window?')) {
                    window.close();
                  }
                }, 1000);
              }, 500);
            }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
    
    showMessage('Thermal receipt opened for printing', 'success');
    onClose();
  };

  const downloadTxtFile = () => {
    const receiptText = generateThermalReceipt();
    const element = document.createElement('a');
    const file = new Blob([receiptText], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = `thermal-receipt-${invoicedetails?.MTD_SERIAL_NO || 'invoice'}.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    showMessage('TXT file downloaded successfully!', 'success');
  };

  const copyToClipboard = async () => {
    try {
      const receiptText = generateThermalReceipt();
      await navigator.clipboard.writeText(receiptText);
      showMessage('Receipt text copied to clipboard!', 'success');
    } catch (err) {
      showMessage('Failed to copy text to clipboard', 'error');
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={1}>
            <ReceiptLong color="primary" />
            Thermal Receipt Printing
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Optimized for 80mm thermal printers
          </Typography>
          
          <Card variant="outlined" sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Preview (Thermal Format)
              </Typography>
              <Paper 
                variant="outlined" 
                sx={{ 
                  p: 2, 
                  backgroundColor: '#f5f5f5', 
                  fontFamily: 'Courier New, monospace', 
                  fontSize: '12px', 
                  lineHeight: '1.2', 
                  whiteSpace: 'pre',
                  maxHeight: '400px',
                  overflow: 'auto',
                  border: '1px dashed #ccc'
                }}
              >
                {generateThermalReceipt()}
              </Paper>
            </CardContent>
          </Card>

          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button 
              variant="outlined" 
              onClick={downloadTxtFile}
              startIcon={<Download />}
              size="small"
            >
              Download TXT
            </Button>
            <Button 
              variant="outlined" 
              onClick={copyToClipboard}
              startIcon={<ContentCopy />}
              size="small"
            >
              Copy Text
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button 
            onClick={printThermalReceipt} 
            variant="contained" 
            color="primary"
            startIcon={<Print />}
          >
            Print Thermal Receipt
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar 
        open={printStatus.open} 
        autoHideDuration={6000} 
        onClose={() => setPrintStatus({ ...printStatus, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          severity={printStatus.severity} 
          onClose={() => setPrintStatus({ ...printStatus, open: false })}
        >
          {printStatus.message}
        </Alert>
      </Snackbar>
    </>
  );
};

// Main Invoice Component
export default function Invoice() {
  const { patientId, serial_no } = useParams();
  const [patients, setPatients] = useState(null);
  const [invoicedetails, setInvoicedetails] = useState(null);
  const [treatmentamount, setTreatmentamount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("percentage");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [thermalDialogOpen, setThermalDialogOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [treatmentRes, patientRes] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
          ),
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
          ),
        ]);
        setInvoicedetails(treatmentRes.data);
        setTreatmentamount(treatmentRes.data.MTD_AMOUNT || 0);
        setPatients(patientRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.response?.data?.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [patientId, serial_no]);

  const calculateSubtotal = () => {
    if (invoicedetails && invoicedetails.Drugs) {
      const total = invoicedetails.Drugs.reduce(
        (total, drug) => total + drug.MDD_AMOUNT,
        0
      );
      return total.toFixed(2);
    }
    return 0;
  };

  const calculateTotalAmount = () => {
    const subtotal =
      parseFloat(calculateSubtotal()) + parseFloat(treatmentamount);
    let totalAmount = subtotal;

    if (discountType === "percentage") {
      totalAmount -= (subtotal * discount) / 100;
    } else {
      totalAmount -= discount;
    }

    return totalAmount.toFixed(2);
  };

  const printInvoice = () => {
    const noPrintElements = document.querySelectorAll('.no-print');
    noPrintElements.forEach(element => {
      element.style.display = 'none';
    });

    const printStyles = document.createElement('style');
    printStyles.innerHTML = `
    @media print {
      body * {
        visibility: hidden;
      }
      
      #invoice-content, #invoice-content * {
        visibility: visible;
      }
      
      #invoice-content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
      }
      
      .MuiContainer-root {
        max-width: none !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      
      .MuiPaper-root {
        box-shadow: none !important;
        border: none !important;
        margin: 0 !important;
        padding: 20px !important;
      }
      
      @page {
        size: A4;
        margin: 15mm;
      }
    }
  `;

    document.head.appendChild(printStyles);
    window.print();

    setTimeout(() => {
      document.head.removeChild(printStyles);
      noPrintElements.forEach(element => {
        element.style.display = '';
      });
    }, 100);
  };

  const downloadInvoice = () => {
    const element = document.getElementById("invoice-content");
    const opt = {
      margin: [10, 10, 10, 10],
      filename: `invoice_${patientId}_${serial_no}.pdf`,
      image: {
        type: "jpeg",
        quality: 0.98
      },
      html2canvas: {
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        ignoreElements: function (element) {
          return element.classList.contains('no-print');
        }
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        floatPrecision: 16
      },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    const tempStyles = document.createElement('style');
    tempStyles.innerHTML = `
      .invoice-number-pdf {
        backgroundColor: theme.palette.secondary.main;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    `;
    document.head.appendChild(tempStyles);

    html2pdf().set(opt).from(element).save().then(() => {
      document.head.removeChild(tempStyles);
    });
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
          <Typography variant="h6" color="error">
            {error}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }} className="no-print">
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          variant="outlined"
        >
          Back to Records
        </Button>
      </Box>

      <StyledPaper elevation={3} id="invoice-content">
        <HeaderBox>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              src={logo}
              alt="Medicare Logo"
              variant="rounded"
              sx={{ width: 80, height: 80, '@media print': { width: 60, height: 60 } }}
            />
            <Box>
              <Typography variant="h5" fontWeight="bold" color="primary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
                AURA MEDITATION
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                No:128/1,Pahala karagahamuna,Kadawatha.
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Tel: 0114532108 | 0117905805 | Email: akdldhshana@gmail.com
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Web: aurameditation.dockyardsoftware.com
              </Typography>
            </Box>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Typography variant="h5" color="primary" fontWeight="bold" sx={{ '@media print': { fontSize: '1.5rem' } }}>
              Payment Receipt
            </Typography>
            <InvoiceNumberBox className="invoice-number-pdf">
              Invoice - {invoicedetails?.MTD_SERIAL_NO || "N/A"}
            </InvoiceNumberBox>
          </Box>
        </HeaderBox>

        <Divider sx={{ my: 3 }} />

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 2, sm: 3 },
            mb: 4,
            alignItems: "center",
            justifyContent: "space-between",
            '& > *': {
              flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 24px)', md: '1 1 calc(25% - 24px)' },
              minWidth: { xs: '100%', sm: '200px' },
              display: "flex",
              alignItems: "center",
              gap: 1,
            },
            '@media print': {
              gap: 2,
              marginBottom: '16px',
              '& > *': {
                flex: '1 1 calc(25% - 16px)',
                minWidth: 'auto'
              }
            }
          }}
        >
          <Box>
            <Person color="primary" />
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Patient Name
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
                {patients?.MPD_PATIENT_NAME}
              </Typography>
            </Box>
          </Box>

          <Box>
            <Home color="primary" />
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Address
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{
                '@media print': { fontSize: '1rem' },
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}>
                {patients?.MPD_ADDRESS || "Not specified"}
              </Typography>
            </Box>
          </Box>

          <Box>
            <CalendarToday color="primary" />
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Date
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
                {new Date().toLocaleDateString()}
              </Typography>
            </Box>
          </Box>

          <Box>
            {patients?.MPD_GENDER === "Male" ? (
              <Male color="primary" />
            ) : (
              <Female color="primary" />
            )}
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Gender / Age
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
                {patients?.MPD_GENDER} /{" "}
                {patients?.MPD_BIRTHDAY
                  ? new Date().getFullYear() -
                  new Date(patients.MPD_BIRTHDAY).getFullYear()
                  : "N/A"}
              </Typography>
            </Box>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ border: "1px solid #eee", mb: 4 }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: "primary.main" }}>
              <TableRow>
                <TableCell sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}>
                  Treatment Description
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Rate (Rs)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Quantity
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Amount (Rs)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoicedetails?.Drugs?.map((medicinedetail, index) => (
                <TableRow key={index} hover>
                  <TableCell sx={{ '@media print': { fontSize: '0.9rem' } }}>{medicinedetail.DrugName}</TableCell>
                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_RATE
                      ? new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(Number(medicinedetail.MDD_RATE))
                      : "0.00"}
                  </TableCell>

                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_QUANTITY
                      ? new Intl.NumberFormat('en-US').format(Number(medicinedetail.MDD_QUANTITY))
                      : "0"}
                  </TableCell>

                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_AMOUNT
                      ? new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(Number(medicinedetail.MDD_AMOUNT))
                      : "0.00"}
                  </TableCell>
                </TableRow>
              ))}

              <TotalRow>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Total Treatment Fee:
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(Number(calculateSubtotal()))}
                </TableCell>
              </TotalRow>

              <TotalRow>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Treatment Fee:
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(Number(treatmentamount))}
                </TableCell>
              </TotalRow>

              <TotalRow>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Subtotal:
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(
                    Number(calculateSubtotal()) + Number(treatmentamount)
                  )}
                </TableCell>
              </TotalRow>

              <DiscountRow>
                <TableCell colSpan={1}></TableCell>
                <TableCell>
                  <Typography fontWeight="bold" sx={{ '@media print': { fontSize: '1rem' } }}>Discount</Typography>
                  <RadioGroup
                    row
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    sx={{ mt: 1 }}
                  >
                    <FormControlLabel
                      value="percentage"
                      control={<Radio size="small" />}
                      label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Percentage</Typography>}
                    />
                    <FormControlLabel
                      value="fixed"
                      control={<Radio size="small" />}
                      label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Fixed Amount</Typography>}
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell align="right">
                  <TextField
                    type="number"
                    size="small"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                    inputProps={{
                      min: "0",
                      max:
                        discountType === "percentage"
                          ? "100"
                          : parseFloat(calculateSubtotal()) +
                          parseFloat(treatmentamount),
                    }}
                    sx={{ width: 120 }}
                  />
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  {discountType === "percentage"
                    ? `${discount}%`
                    : `Rs: ${discount}`}
                </TableCell>
              </DiscountRow>

              <TotalRow sx={{ backgroundColor: "primary.light" }}>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}>
                  <Typography variant="h6">Final Amount:</Typography>
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}
                >
                  <Typography variant="h6">
                    Rs: {new Intl.NumberFormat('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }).format(Number(calculateTotalAmount()))}
                  </Typography>
                </TableCell>
              </TotalRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          sx={{
            mt: 6,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <Box
            sx={{
              width: 300,
              textAlign: "center",
              p: 2,
            }}
          >
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" color="text.secondary" sx={{ '@media print': { fontSize: '0.9rem' } }}>
              Authorized Signature
            </Typography>
            <Typography variant="h6" fontWeight="bold" sx={{ mt: 2, '@media print': { fontSize: '1.1rem' } }}>
              Aura Meditation
            </Typography>
          </Box>
        </Box>
      </StyledPaper>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          mt: 4,
          "@media print": {
            display: "none",
          },
        }}
        className="no-print"
      >
        <Tooltip title="Print standard invoice">
          <Button
            variant="contained"
            color="primary"
            startIcon={<Print />}
            onClick={printInvoice}
            sx={{ px: 4, py: 1.5 }}
          >
            Print Invoice
          </Button>
        </Tooltip>

        <Tooltip title="Print thermal receipt">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<ReceiptLong />}
            onClick={() => setThermalDialogOpen(true)}
            sx={{ px: 4, py: 1.5 }}
          >
            Thermal Receipt
          </Button>
        </Tooltip>

        <Tooltip title="Download as PDF">
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Download />}
            onClick={downloadInvoice}
            sx={{ px: 4, py: 1.5 }}
          >
            Download PDF
          </Button>
        </Tooltip>
      </Box>

      {/* Thermal Receipt Dialog */}
      <ThermalReceipt
        open={thermalDialogOpen}
        onClose={() => setThermalDialogOpen(false)}
        patients={patients}
        invoicedetails={invoicedetails}
        treatmentamount={treatmentamount}
        discount={discount}
        discountType={discountType}
        calculateSubtotal={calculateSubtotal}
        calculateTotalAmount={calculateTotalAmount}
      />
    </Container>
  );
}

